import Trans from "modules/Trans";
import { countries, langs, splangs } from "db";

export const trans = new Trans(window.i18nMessages);

const ccies = {};

export const formatCurrency = (value, ccy) => {
	if (!(ccy in ccies))
		ccies[ccy] = new Intl.NumberFormat(document.documentElement.lang, { style: "currency", currency: ccy });

	return ccies[ccy].format(value / 100);
};

const countryNames = {};

for (const country of countries)
	countryNames[country.country_id] = country.name;

export const countryName = (country) => countryNames[country] || country;

const languageNames = {};

for (const lang of langs)
	languageNames[lang.lang_id] = lang.name;

for (const lang of splangs)
	languageNames[lang.lang_id] = lang.name;

export const languageName = (lang) => languageNames[lang] || lang;

export const i18n = (app) => {
	const gProps = app.config.globalProperties;

	gProps.$gettext = (...args) => trans.gettext(...args);
	gProps.$ngettext = (...args) => trans.ngettext(...args);
	gProps.$pgettext = (...args) => trans.pgettext(...args);

	gProps.$countryName = countryName;
	gProps.$languageName = languageName;
	gProps.$lcurrency = formatCurrency;
};

window.vixI18n = { countryName, languageName, formatCurrency, i18n, trans };
